import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {Router, RouterModule} from '@angular/router';
import {ApiAgentService} from '../../services/api-agent.service';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, RouterModule],
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  loading: boolean;
  serverMsg: string;
  serverInfo: string;
  recoverForm: FormGroup;
  otpForm: FormGroup;
  submitted: boolean;
  currentStep: string;
  isSubAccount: boolean;
  @ViewChild('password') password: ElementRef;
  @ViewChild('otp') otp: ElementRef;


  constructor(private loader: GlobalLoaderService,
              private translate: TranslateService,
              private formBuilder: FormBuilder,
              private router: Router,
              private api: ApiAgentService) {
  }


  ngOnInit() {
    this.isSubAccount = false;
    this.currentStep = 'mobile';
    this.loading = false;
    this.recoverForm = this.formBuilder.group({
      mobile: ['', [Validators.required]],
    });

    this.otpForm = this.formBuilder.group({
      mobile: ['', [Validators.required]],
      otp: ['', [Validators.required]],
      password: ['', [Validators.required]],
    });
    this.loading = false;
  }

  // @ts-ignore
  get rf() {
    return this.recoverForm.controls;
  }

  // @ts-ignore
  get of() {
    return this.otpForm.controls;
  }

  submitOtp($event) {
    this.submitted = true;
    if (this.otpForm.valid) {
      this.loading = true;
      $event.preventDefault();

      this.api.changePassword(this.otpForm.value['mobile'], this.otpForm.value['otp'], this.otpForm.value['password'], this.isSubAccount)
        .then(value => {
          this.currentStep = 'success';
          this.translate.get('Password changed successfully. Please login now.')
            .subscribe((value) => this.serverInfo = value, (error) => this.serverInfo = 'Password changed successfully. Please login now.');
        })
        .catch(reason => {
          this.translate.get('Could not recover password. Please try again.')
            .subscribe((value) => this.serverMsg = value, (error) => this.serverMsg = 'Could not recover password. Please try again.');
        }).finally(() => {
        this.loading = false;
      });
    }
  }

  sendMobile($event) {
    this.submitted = true;
    if (this.recoverForm.valid) {
      this.loading = true;
      $event.preventDefault();
      this.api.resetPassword(this.recoverForm.value['mobile'], this.isSubAccount)
        .then(value => {
          this.currentStep = 'otp';
          this.submitted = false;
          this.otpForm.patchValue({
            mobile: this.recoverForm.value['mobile']
          });
        })
        .catch(reason => {
          this.translate.get('Could not recover password. Please try again.')
            .subscribe((value) => this.serverMsg = value, (error) => this.serverMsg = 'Could not recover password. Please try again.');
        }).finally(() => {
        this.loading = false;
      });
    }
  }

  togglePassword() {
    this.password.nativeElement.type = this.password.nativeElement.type == 'password' ? 'text' : 'password';
  }

  toggleOtp() {
    this.otp.nativeElement.type = this.otp.nativeElement.type == 'password' ? 'text' : 'password';
  }

  toggleSubAccount() {
    this.isSubAccount = !this.isSubAccount;
  }
}
